import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage.jsx";
import LandingPage from "./pages/LandingPage.jsx";
import CampaignPage from "./pages/CampaignPage.jsx";
import DocCenterPage from "./pages/DocCenterPage.jsx";
import BrokerComPage from "./pages/CMS/BrokerComPage.jsx";
import CategoriesPage from "./pages/CMS/CategoriesPage.jsx";
import EventCalendarPage from "./pages/CMS/EventCalendarPage.jsx";
import QuickLinksPage from "./pages/CMS/QuickLinksPage.jsx";
import CreateCampaignPage from "./pages/CreateCampaignPage.jsx";
import EditCampaignPage from "./pages/EditCampaignPage.jsx";
import EditDocumentPage from "./pages/EditDocumentPage.jsx";
import ViewDocumentPage from "./pages/ViewDocumentPage.jsx";
import CampaignDetailPage from "./pages/CampaignDetailPage.jsx";
import CreateDocCenterPage from "./pages/CreateDocCenterPage.jsx";
import SubCategoriesPage from "./pages/CMS/SubCategoriesPage.jsx";
import UsrAuth from "./utils/usrAuth.js";
import PlusNavbar from "./components/PlusNavbar.jsx";
import "bootstrap/dist/css/bootstrap.css";

function App() {
  const nav = [
    { component: <LandingPage />, link: "/" },
    { component: <CampaignPage />, link: "Campaign" },
    { component: <DocCenterPage />, link: "DocCenter" },
    { component: <BrokerComPage />, link: "BrokerCom" },
    { component: <CategoriesPage />, link: "Categories" },
    { component: <SubCategoriesPage />, link: "SubCategories" },
    { component: <EventCalendarPage />, link: "EventCalendar" },
    { component: <QuickLinksPage />, link: "QuickLinks" },
    { component: <CreateCampaignPage />, link: "CreateCampaign" },
    { component: <CreateDocCenterPage />, link: "CreateDoc" },
    { component: <EditCampaignPage />, link: "EditCampaign" },
    { component: <EditDocumentPage />, link: "EditDocument" },
    { component: <ViewDocumentPage />, link: "ViewDocument" },
    { component: <CampaignDetailPage />, link: "CampaignDetail" },
  ];
  return (
    <Router>
      <PlusNavbar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {nav.map(({ component, link }) => (
          <Route
            key={link}
            path={link}
            element={<UsrAuth>{component}</UsrAuth>}
          />
        ))}
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </Router>
  );
}

export default App;
